<template>
	<div style="width: 100%;height: 100%;">
		<div style="background-color: white;font-size: 18px;height: 50px;line-height: 50px;text-align: center;padding-right: 30px;border-bottom: 1px solid #F6F6F6;">
			<img @click="toIndex()" src="../../assets/fImage/zuojiantou.png" style="float: left;padding-left: 10px;height: 20px;width: 20px;padding-top: 15px;">
			结果反馈
		</div>
		<div style="background-color: white;">
			<div style="height: 50px;line-height: 50px;width: 100%;border-bottom: 1px solid #F6F6F6;width: 90%;margin-left: 5%;margin-right: 5%;margin-top: 20px;">
				<el-input
					type="textarea"
					placeholder="请输入内容"
					v-model="textarea"
					maxlength="200"
					show-word-limit
					:rows="5"
				>
				</el-input>
			</div>
		</div>
		<div @click="submit()" style="margin-top: 100px;margin-left: 5%;margin-right: 5%;background-color: #00A9F2;color: white;border-radius: 5px;height: 40px;font-size: 14px;line-height: 40px;text-align: center;">
			提 交
		</div>
	</div>
</template>

<script>
	import {addFeedBack} from "@/api/reservation";
	import Cookies from 'js-cookie';
	export default {
		name: "Index",
		data() {
			return {
				textarea:'',
				phone: Cookies.get('phone'),
			}
		},
		mounted() {
		},
		methods: {
			toIndex() {
				this.$router.push(
					{
						path:'/phone/index',
					}
				);
			},
			submit(){
				let _this = this
				if(!this.textarea){
					_this.$message.error("请输入反馈内容")
					return;
				}
				addFeedBack(this.phone,this.textarea).then(data => {
						console.log(data)
						if(data.data == 1){
							_this.$message.success("提交成功")
							this.$router.push(
								{
									path:'/phone/index',
								}
							);
						}else{
							_this.$message.error("提交失败")
						}
					}).catch(error =>{
						_this.$message.error(error)
					})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
